import { doDelete, doGet, doPost, doPut } from '../http/httpHelper';

export const listSapProductBranch = async () => {
    const resp = await doGet('/sapProductBranch');
    return resp;
};

export const getSapProductBranchById = async (sapCode, branchId) => {
    const resp = await doGet(`/sapProductBranch/${sapCode}/${branchId}`);
    return resp;
};

export const createSapProductBranch = async (payload) => {
    const resp = await doPost('/sapProductBranch', payload);
    return resp;
};

export const editSapProductBranch = async (sapCode, branchId, payload) => {
    const resp = await doPut(`/sapProductBranch/${sapCode}/${branchId}`, payload);
    return resp;
};

export const delSapProductBranch = async (sapCode, branchId) => {
    const resp = await doDelete(`/sapProductBranch/${sapCode}/${branchId}`);
    return resp;
};

export const bulkSapProductBranch = async (records) => {
    const resp = await doPost('/sapProductBranch/bulk', { records });
    return resp;
};
